import React from "react";
import NavigationBar from '../components/nav';
import Demographics from "../components/patientdata/demographics/demographics";
import  '../components/patientdata/demographics/demographics.css'
import GDSForm from '../components/patientdata/gds/gds'
import {Container,Tabs,Tab,Button,Modal} from "react-bootstrap";
import Scopa_aut from "../components/patientdata/scopa_aut/scopa_aut"
import Sas from "../components/patientdata/SAS/sas"
import Fab from "../components/patientdata/FAB/fab"
import  Moca from "../components/patientdata/moca/moca";
import Seadl from "../components/patientdata/seadl/seadl";
import Hoehn_yahr from "../components/patientdata/hoehn_yarh/hoehn_yarh"
import Umsars from "../components/patientdata/umsars/umsars";
import PspDs from "../components/patientdata/PSP-DS/psp-ds"
import Updrs from "../components/patientdata/UPDRS/updrs"
import Psp from "../components/patientdata/psp/psp"
import PDQ from "../components/patientdata/PDQ/pdq"
import {Redirect} from "react-router-dom"
import app from "../login/firebase";
import axios from "axios";
import ErrorPopup from "../components/utilities/errors/errorPopup"
import RBDQS from "../components/patientdata/RBDQS/rbdqs"
import ImagingBiomarkers from "../components/patientdata/imaging_biomarkers/ImagingBiomarkers"
import PersonalHistory from "../components/patientdata/demographics/personalHistory"
import ClinicalAndDiagnosis from "../components/patientdata/ClinicalCriteriaAndDiagnosis/ClinicalAndDiagnosis"
import FamilyHistory from  "../components/patientdata/demographics/familyHistory"
import MedicalHistory from "../components/patientdata/demographics/medicalHistory"
import CurrentTreatment from  "../components/patientdata/demographics/currentTreatment"
import DateOfVisit from "../components/utilities/datePopup/date";
import NMSS from "../components/patientdata/NMSS/nmss";
import MMSE from "../components/patientdata/mmse/mmse";
import IPAQ from "../components/patientdata/IPAQ/ipaq";
import MEDAS from "../components/patientdata/MEDAS/medas";

import {Route} from 'react-router-dom'
import CGI from "../components/patientdata/CGI/cgi";
import CISI from "../components/patientdata/CISI/cisi";
import GCF_TMT from "../components/patientdata/GCF_TMT/gcf_tmt";
class  NewPatientPage extends React.Component{
    constructor() {
        super();
        this.state ={
            data :{
                // demographics:{
                //     personal_info: {},
                //     current_treatment:{},
                //     medical_history:{},
                //     family_history:{}
                // },
                personal_info:{gender:""},
                fab:{},
                gds:{},
                hoehn_yarh:{},
                moca:{},
                psp:{},
                psp_cds:{},
                sas:{},
                scopa_aut:{},
                seadl:{},
                umsars:{},
                updrs:{},
                pdq:{},
                rbdsq:{},
                nmss:{},
                gcf_tmt:{},
                visits:{}
            },
            successStatus:false ,
            patient_id:"",
            disableSubmit:true,
            error:false,
            fetchLink:"",
            checkSubmit:false,
            showDatePopup:false,
            
        }
        // this.handleDemographicChange = this.handleDemographicChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChangeWithState = this.handleChangeWithState.bind(this)
        this.handleDatePopup = this.handleDatePopup.bind(this)
    }

    handleDemographicChange = async (field,event) => {
        if(event.target){
            const {name, value} = event.target
            await this.setState((prevState) => (
                    {
                        ...prevState,
                        data:{
                            ...prevState.data,
                            demographics: {
                                ...prevState.data.demographics,
                                [field]:{
                                    ...prevState.data.demographics[field],
                                    [name] : value
                                }
                            }
                        }
                    }
                )
            );
        }
        else{ // CLEARING STATE IF ANSWERS SWITCH FROM YES TO NO. CHECK YesNoFamily component, current treatment,imagingbiomarkers
            const {name,value} = event;
            await this.setState((prevState) => (
                {
                    ...prevState,
                    data:{
                        ...prevState.data,
                        demographics: {
                            ...prevState.data.demographics,
                            [field]:{
                                ...prevState.data.demographics[field],
                                [name] : value
                            }
                        }
                    }
                }
            )
        );
            
        }

           
    }
    handleDemographicChangeTreatment = async (field,fname,event) => {
        const {name, value} = event.target
        await this.setState((prevState) => (
                {
                    ...prevState,
                    demographics: {
                        ...prevState.demographics,
                        [field]:{
                            ...prevState.demographics[field],
                            [fname]:{
                                ...prevState.demographics[field][fname],
                                [name]:value
                            }
                        }
                    }
                }
            )
        );

    }
    handlePatientID = async (event)=> {
        const {name,value} = event.target
        
        await this.setState((prevState)=>(
                {
                    ...prevState,
                    patient_id:value,
                   
                }
            ),()=>{
                if(value !="" && this.state.data.personal_info.gender!=""){
                    this.setState({disableSubmit:false,checkSubmit:true})
                }
                else{
                    this.setState({disableSubmit:true})
                }
            })
        
    }
    handleGender = async (event) =>{
        var {name,value} = event.target
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                       personal_info:{
                           ...prevState.data.personal_info,
                            [name]:value
                       }
                }
            }
        ),()=>{
            if(value !="" && this.state.patient_id!=""){
                this.setState({disableSubmit:false,checkSubmit:true})
            }
            else{
                this.setState({disableSubmit:true})
            }
        })
    }
    handleDate = async (event) =>{
        var {name,value} = event.target
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                       visits:{
                           ...prevState.data.visits,
                            [name]:value
                       }
                }
            }
        ),()=>{
            if(value !="" && this.state.patient_id!=""){
                this.setState({disableSubmit:false,checkSubmit:true})
            }
            else{
                this.setState({disableSubmit:true})
            }
        })
    }
    handleClinicalPspMsa  = async(field,event)=>{
        // const form  = event.currentTarget
       
       
        if(event.target){
            var {name,value} = event.target
        }
        else{
            var {name,value} = event //articial event
        }
       
         this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                        [field]:{
                            ...prevState.data[field],
                            [name] : value
                        }
                }
            }
        ))
        
    }
    handleChange = async(field,event)=>{
        // const form  = event.currentTarget
       
       
        var {name,value} = event.target
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                        [field]:{
                            ...prevState.data[field],
                            [name] : value
                        }
                }
            }
        ),()=>{
            if(name =="gender"){

            }
        })
        
    }
    handleChangeWithObject =  async(field,object) =>{
        await this.setState((prevState)=>(
           { ...prevState,
            data:{
            ...prevState.data,
            [field]:object
            }
        }
        ))
    }
    handleImaging = (income_state) =>{
       
        this.setState(prevState=>({data:{...prevState.data,...income_state}}))
    }
     handleChangeWithState(field,income_state){
         this.setState((prevState)=>(
            {
                ...prevState,
                data:{
                    ...prevState.data,
                    [field]:income_state
                }
            }
        ))
        
    }
    
    validate(){
        if(!this.state.personal_info.gender){
            return false
        }
    }
    handleDatePopup(action){
        if (action == "show"){
            this.setState((prevState)=>(
                {
                    ...prevState,
                    showDatePopup:true
                }
            ))
        }
        else {
            this.setState((prevState)=>(
                {
                    ...prevState,
                    showDatePopup:false,
                    data:{
                        ...prevState.data,
                        visits:{}
                    }
                }
            ))
        }
    }
    handleSubmit(){
        let func = this
        
            app.auth().currentUser.getIdToken(true).then(function(idToken){
                    
                    axios.post(process.env.REACT_APP_newPatientURL,(func.state.data),{
                            headers:{'Content-Type': 'application/json','authorization':idToken,'patient_id':func.state.patient_id}
                    }).then((response)=>{
                        if (response.status ==200){
                            func.props.history.push("/")
                        }
                        else{
                            alert(response.statusText)
                        }
                    }).catch((error)=>  { })
            }
            ).catch((error)=>{
                alert(error)
                
                
            })
        
        
        // axios.post("http://localhost:5000/api/patients/new",func.state.data,{
        //     headers:{'Content-Type': 'application/json','authorization':idToken,'patient_id':[func.state.patient_id]}
        // })
    
    }
    closeError = ()=>{
        this.setState({"error":false})
    }
    async componentDidMount(){
        // fetch("settings.json").then(function(response){
        //     const resp = response.json()
        //     return resp
        // }).then( async response=> await this.setState({fetchLink:response["newPatientURL"]}))
    }
    componentDidUpdate(prevProps,prevState){
        if (prevState != this.state){
            // if((this.state.patient_id!="" && this.state.data.personal_info.gender!="")&&!this.state.checkSubmit){
            //     this.setState({disableSubmit:false,checkSubmit:true})
            // } 

            
        }
    }
    render() {
        if (this.state.successStatus){
            return(
                <Redirect push to={{
                    pathname:'/',
                    state:{subStatus:'success'}
                    
                }}/>
            )
        }

        return (
            <div>
                {/* <Route component={PersonalHistory}/> */}
                <NavigationBar newPatient={true} submit={this.handleDatePopup} disableSubmit={this.state.disableSubmit}transition={'fade'}/>
                    <Container fluid className={'container-item'}>
                   
                    <DateOfVisit show={this.state.showDatePopup} handleSubmit={this.handleSubmit} onChange={this.handleDate} handleDatePopup={this.handleDatePopup} defaultVisitNo={1}/>



                    <Tabs defaultActiveKey={'personal_history'}  >
                        {/* <Tab eventKey={'Demographics'} title={'Demographics'}>

                          
                            <Demographics handler={this.handleChange} patientID={this.handlePatientID}/>
                           
                         

                        </Tab> */}
                        <Tab eventKey={'personal_history'} title={"Personal History"}>
                            <PersonalHistory handler={this.handleChange} handleGender={this.handleGender} patientID={this.handlePatientID}/>
                        </Tab>
                        <Tab eventKey={'family_history'} title={'Family History'}>
                            <FamilyHistory  handler={this.handleChange}/>

                        </Tab>
                        <Tab eventKey={'medical_history'} title={"Medical History"}>
                        <MedicalHistory handler={this.handleChange}/>
                        </Tab>
                        <Tab eventKey={'current_treatment'} title={'Current Treatment'}>
                            <CurrentTreatment handler={this.handleChange}/>
                        </Tab>
                        {/* <Tab eventKey={'clinical_criteria'} title={"Diagnostic Criteria"}>
                            <ClinicalCriteria handler={this.handleChangeWithState}/>
                        </Tab> */}
                        <Tab eventKey={'diagnosis_diagnostic_criteria'} title={"Diagnosis and Diagnostic Criteria"} mountOnEnter>
                            <ClinicalAndDiagnosis handler={this.handleChangeWithState} handler1={this.handleChange} handlePspMsaAuto={this.handleClinicalPspMsa} />
                        </Tab>
                        
                        <Tab eventKey={'hoehn_yahr'} title={'H&Y'} mountOnEnter={true}>
                            <Hoehn_yahr handler={this.handleChangeWithObject}/>
                        </Tab>
                        <Tab eventKey={'updrs'} title={'UPDRS-IV'} mountOnEnter={true}>
                            <Updrs handler={this.handleChangeWithObject} />
                        </Tab>
                        <Tab eventKey={'psp'} title={'PSP-RS'}>
                            <Psp handler={this.handleChangeWithObject} mountOnEnter={true}/>
                        </Tab>
                        <Tab eventKey={'psp-ds'} title={'PSP-CDS '} mountOnEnter={true}>
                            <PspDs handler={this.handleChangeWithObject} mountOnEnter={true}/>
                        </Tab>
                        <Tab eventKey={'umsars'} title={'UMSARS'} mountOnEnter={true}>
                            <Umsars handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'GDS'} title={'GDS'} mountOnEnter={true}>
                            <GDSForm handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'SCOPA-AUT'} title={'SCOPA-AUT'} mountOnEnter={true}>
                            <Scopa_aut handler={this.handleChangeWithState} gender={this.state.data.personal_info.gender}/>
                        </Tab>
                        <Tab eventKey={'sas'} title={'SAS'} mountOnEnter={true}>
                            <Sas handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'fab'} title={'FAB'} mountOnEnter={true}>
                            <Fab handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'moca'} title={'MOCA'} mountOnEnter={true}>
                            <Moca handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'seadl'} title={'SEADL'} mountOnEnter={true}>
                            <Seadl handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'rbdsq'} title={'RBDSQ'}mountOnEnter={true}>
                            <RBDQS handler={this.handleChangeWithState}/>

                        </Tab>             
                        <Tab eventKey={'PDQ'} title={'PDQ-8'}>
                            <PDQ handler={this.handleChangeWithState} mountOnEnter={true}/>

                        </Tab>
                        <Tab eventKey={'imaging_biomarkers'} title={"Imaging and Biomarkers"} mountOnEnter={true}>
                            <ImagingBiomarkers handler={this.handleImaging}/>
                        </Tab>
                        <Tab eventKey={'nmss'} title={"NMSS"} mountOnEnter={true}>
                            <NMSS handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'mmse'} title={"MMSE"} mountOnEnter={true}>
                            <MMSE handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'CGI'} title={"CGI"} mountOnEnter={true}>
                            <CGI handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'CISI'} title={"CISI"} mountOnEnter={true}>
                            <CISI handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'IPAQ'} title={"IPAQ"} mountOnEnter={true}>
                            <IPAQ handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'MEDAS'} title={"MEDAS"} mountOnEnter={true}>
                           <MEDAS handler={this.handleChangeWithState}/>
                        </Tab>
                        <Tab eventKey={'gcf_tmt'} title={"GCF / TMT"} mountOnEnter={true}>
                            <GCF_TMT handler={this.handleChangeWithState}/>
                        </Tab>
                    </Tabs>
                  
                    </Container>
                   
                   
                    <ErrorPopup text={this.state.error} show={this.state.error == false?false:true} hide={this.closeError}/>
            </div>
        )
    }
}
export default NewPatientPage;